import React from 'react';
import styles from './CreateSegmentDialog.module.css';

interface DialogHeaderProps {
  title: string;
  subtitle: string;
  onClose: () => void;
  showCloseButton?: boolean;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  subtitle,
  onClose,
  showCloseButton = false,
}) => {
  return (
    <div className={styles.dialogHeader}>
      <div>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
      {showCloseButton && (
        <button
          type="button"
          onClick={onClose}
          className={styles.closeButton}
          aria-label="Close dialog">
          ×
        </button>
      )}
    </div>
  );
};
